
define('text!modules/form/background_template.html',[],function () { return '<h5 class="form-label">\r\n  <%- label %>\r\n</h5>\r\n<div class="form-field form-field--image read-only">\r\n  <img src="<%-value%>" alt="" />\r\n  <div style="float: right" class="js-media-fact-connection"></div>\r\n</div>\r\n\r\n';});

